/*==================================================
OVOSANTI INTERACTIVE SHOWCASE
Premium Accordion v4.0
==================================================*/

class OvosInteractiveShowcase {

    constructor(section){

        this.section = section;

        /*==============================
        ELEMENTS
        ==============================*/

        this.items = [
            ...section.querySelectorAll(".ovos-showcase__item")
        ];

        this.triggers = [
            ...section.querySelectorAll(".ovos-showcase__trigger")
        ];

        this.panels = [
            ...section.querySelectorAll(".ovos-showcase__panel")
        ];

        this.media = [
            ...section.querySelectorAll(".ovos-showcase__media")
        ];

        /*==============================
        SETTINGS
        ==============================*/

        this.current = 0;

        this.timer = null;

        this.hover = false;

        this.animating = false;

        this.autoplay =
            section.dataset.autoplay === "true";

        this.delay =
            (Number(
                section.dataset.autoplaySpeed
            ) || 5) * 1000;

        this.duration =
            Number(
                getComputedStyle(section)
                .getPropertyValue("--animation-duration")
                .replace("ms","")
            ) || 650;

        this.reduceMotion =
            window.matchMedia(
                "(prefers-reduced-motion: reduce)"
            ).matches;

        this.init();

    }

    /*==================================================
    INIT
    ==================================================*/

    init(){

        if(!this.items.length){

            return;

        }

        this.bindAccordion();

        this.bindKeyboard();

        this.bindHover();

        this.bindTouch();

        this.open(0,false);

        this.startAutoplay();

    }

    /*==================================================
    ACCORDION
    ==================================================*/

    bindAccordion(){

        this.triggers.forEach((trigger,index)=>{

            trigger.addEventListener("click",()=>{

                if(index===this.current){

                    return;

                }

                this.stopAutoplay();

                this.open(index);

                this.startAutoplay();

            });

        });

    }

    /*==================================================
    OPEN
    ==================================================*/

    open(index,animate=true){

        if(this.animating && animate){

            return;

        }

        this.animating=true;

        this.items.forEach((item,i)=>{

            const active=i===index;

            item.classList.toggle(

                "is-active",

                active

            );

            const trigger=

                this.triggers[i];

            trigger.setAttribute(

                "aria-expanded",

                active

            );

            const panel=

                this.panels[i];

            panel.hidden=!active;

        });

        this.changeImage(index);



        this.current = index;

        window.setTimeout(()=>{

            this.animating=false;

        },this.duration);

    }

    /*==================================================
    IMAGE
    ==================================================*/

    changeImage(index){

        this.media.forEach((image,i)=>{

            image.classList.toggle(

                "is-active",

                i===index

            );

        });

    }

        /*==================================================
    NEXT
    ==================================================*/

    next(){

        let next = this.current + 1;

        if(next >= this.items.length){

            next = 0;

        }

        this.open(next);

    }

    /*==================================================
    PREVIOUS
    ==================================================*/

    previous(){

        let previous = this.current - 1;

        if(previous < 0){

            previous = this.items.length - 1;

        }

        this.open(previous);

    }

    /*==================================================
    AUTOPLAY
    ==================================================*/

    startAutoplay(){

        if(!this.autoplay) return;

        this.stopAutoplay();

        this.timer = window.setInterval(()=>{

            if(this.hover) return;

            if(document.hidden) return;

            if(this.animating) return;

            this.next();

        },this.delay);

    }

    stopAutoplay(){

        if(!this.timer) return;

        clearInterval(this.timer);

        this.timer = null;

    }

    /*==================================================
    HOVER
    ==================================================*/

    bindHover(){

        this.section.addEventListener(

            "mouseenter",

            ()=>{

                this.hover = true;

            }

        );

        this.section.addEventListener(

            "mouseleave",

            ()=>{

                this.hover = false;

            }

        );

    }

    /*==================================================
    TOUCH
    ==================================================*/

    bindTouch(){

        let startX = 0;

        let endX = 0;

        this.section.addEventListener(

            "touchstart",

            (event)=>{

                startX = event.changedTouches[0].clientX;

            },

            { passive:true }

        );

        this.section.addEventListener(

            "touchend",

            (event)=>{

                endX = event.changedTouches[0].clientX;

                const distance = endX - startX;

                if(Math.abs(distance) < 60){

                    return;

                }

                this.stopAutoplay();

                if(distance < 0){

                    this.next();

                }else{

                    this.previous();

                }

                this.startAutoplay();

            },

            { passive:true }

        );

    }



    /*==================================================
    KEYBOARD
    ==================================================*/

        bindKeyboard(){

            document.addEventListener("keydown",(event)=>{

                // No interferir si el usuario escribe
                const tag = document.activeElement.tagName;

                if(
                    tag === "INPUT" ||
                    tag === "TEXTAREA" ||
                    tag === "SELECT"
                ){
                    return;
                }

                switch(event.key){

                    case "ArrowDown":

                    case "ArrowRight":

                        event.preventDefault();

                        this.stopAutoplay();

                            event.preventDefault();

                            this.stopAutoplay();

                            this.next();

                            this.startAutoplay();
                        
                    break;

                    case "ArrowUp":

                    case "ArrowLeft":

                        event.preventDefault();

                        this.stopAutoplay();

                        event.preventDefault();

                        this.stopAutoplay();

                        this.previous();

                        this.startAutoplay();

                    break;

                }

            });

        }

    /*==================================================
    SHOPIFY
    ==================================================*/

    select(index){

        this.stopAutoplay();

        this.open(index,false);

    }

    /*==================================================
    DESTROY
    ==================================================*/

    destroy(){

        this.stopAutoplay();

    }

}

/*==================================================
BOOTSTRAP
==================================================*/

const ovosInstances = new WeakMap();

function initOvosShowcases(root=document){

    root

        .querySelectorAll(".ovos-showcase")

        .forEach(section=>{

            if(ovosInstances.has(section)){

                ovosInstances

                    .get(section)

                    .destroy();

            }

            ovosInstances.set(

                section,

                new OvosInteractiveShowcase(section)

            );

        });

}

/*==================================================
READY
==================================================*/

document.addEventListener(

    "DOMContentLoaded",

    ()=>{

        initOvosShowcases();

    }

);

/*==================================================
SECTION LOAD
==================================================*/

document.addEventListener(

    "shopify:section:load",

    (event)=>{

        initOvosShowcases(event.target);

    }

);

/*==================================================
SECTION UNLOAD
==================================================*/

document.addEventListener(

    "shopify:section:unload",

    (event)=>{

        event.target

            .querySelectorAll(".ovos-showcase")

            .forEach(section=>{

                if(!ovosInstances.has(section)){

                    return;

                }

                ovosInstances

                    .get(section)

                    .destroy();

                ovosInstances

                    .delete(section);

            });

    }

);

/*==================================================
BLOCK SELECT
==================================================*/

document.addEventListener(

    "shopify:block:select",

    (event)=>{

        const block = event.target;

        const section =

            block.closest(".ovos-showcase");

        if(!section) return;

        const instance =

            ovosInstances.get(section);

        if(!instance) return;

        const items = [

            ...section.querySelectorAll(

                ".ovos-showcase__item"

            )

        ];

        const index = items.findIndex(

            item=>item.contains(block)

        );

        if(index >= 0){

            instance.select(index);

        }

    }

);